"use strict";

PF.Field.MultiSelect = class MultiSelect extends PF.Field
	{
	static get options()
		{
		return {
			html: PF.Field.MultiSelect.templates,
			popupConfig: {
				title: 'Выберите значения'
			},
			checkConfig: {
				listConfig: {
					modelsConfig: {}
				}
			},

			label: "Выберите значения",
			listTitle: (count) => `${Util.spell(count, ['Значений не выбрано', 'Выбрано @{v} значение', 'Выбрано @{v} значения', 'Выбрано @{v} значений'])}`,
			simpleTitle: (count) => `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`,
			model: new PF.Model({}),
			key: 'value',

			showInfo: true,
			helper: '',

			errors: {}
		};
		}


	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">&nbsp;</div>

					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
			//language=HTML
			popupContent: `
				<div class="" pf="checkGroup"></div>

				<div class="block">
					<a href="#" class="button button-raised" pf="selectOk">ОК</a>
				</div>
			`,
			//language=HTML
			selectInner: `
				<div class="item-inner">
					<div class="item-title" pf="simpleTitle">
						@{simpleTitleText}
					</div>
				</div>`
		};
		}


	init()
		{
		this.dom.loads(this.html);
		this.dom.element.append(this.dom.wrapper);

		this.popup = new PF.F7Popup({
			dom: {content: this.dom.popupContent},
			...this.popupConfig
		});
		this.dom.select.on('click', () => this.popup.open());
		this.group = new PF.Field.CheckGroup({
			dom: {element: this.dom.checkGroup},
			...this.checkConfig,
			model: this.model,
			key: this.key,
		});

		this.calc('group.list.title', `model.${this.key}.notRemovedCount`, (c) => this.listTitle(c));
		this.calc('simpleTitleText', `model.${this.key}.notRemovedCount`, (c) => this.simpleTitle(c));
		this.dom.load(this.html.selectInner, 'selectInner');
		this.dom.selectInner.bindObject(this);

		this.dom.selectOk.on("click", () => this.popup.close());

		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({wrapper: 'class:focus'}, 'popup.opened');
		this.bindDom({info: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');
		this.bindDom({label: 'html'}, 'label');
		this.bindDom({select: 'class:active'}, 'model.' + this.key + '.notRemovedCount', (c) => c > 0);
		this.bindDom({selected: 'content'}, 'model.' + this.key + '.notRemovedCount', (c) => c === 0 ? '&nbsp;' : this.dom.selectInner);
		}

	};

